/**
 * Convierte el valor de <input type="date"> (YYYY-MM-DD) a ISO para el API.
 * Usa mediodía UTC para que el día civil coincida al mostrar en zonas América/*
 * (evita el desfase de un día respecto a medianoche UTC).
 * @param {string} ymd
 * @returns {string}
 */
export function fechaLimiteDesdeInput(ymd) {
  if (!ymd || typeof ymd !== 'string') {
    return new Date(ymd).toISOString();
  }
  const trimmed = ymd.trim();
  const m = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return new Date(trimmed).toISOString();
  return `${m[1]}-${m[2]}-${m[3]}T12:00:00.000Z`;
}

/** Hora límite por defecto según día (Lima): sáb 13:30, resto 18:00 */
export function horaLimiteDefaultParaFecha(ymd) {
  if (!ymd || typeof ymd !== 'string') return '18:00';
  const m = ymd.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return '18:00';
  const ref = new Date(`${m[1]}-${m[2]}-${m[3]}T12:00:00.000Z`);
  const weekday = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Lima',
    weekday: 'short',
  }).format(ref);
  return weekday === 'Sat' ? '13:30' : '18:00';
}

/**
 * Fecha + hora límite interpretadas en America/Lima (UTC-5).
 * @param {string} ymd YYYY-MM-DD
 * @param {string} hhmm HH:mm
 */
export function fechaLimiteConHoraDesdeInput(ymd, hhmm) {
  if (!ymd) return fechaLimiteDesdeInput(ymd);
  const dm = String(ymd).trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!dm) return new Date(ymd).toISOString();
  const hm = String(hhmm || horaLimiteDefaultParaFecha(ymd)).trim().match(/^(\d{1,2}):(\d{2})$/);
  const h = hm ? parseInt(hm[1], 10) : 18;
  const min = hm ? parseInt(hm[2], 10) : 0;
  const utc = new Date(Date.UTC(
    parseInt(dm[1], 10),
    parseInt(dm[2], 10) - 1,
    parseInt(dm[3], 10),
    h + 5,
    min,
    0
  ));
  return utc.toISOString();
}

/** Extrae HH:mm en Lima desde un ISO guardado en BD */
export function horaLimiteDesdeIso(iso) {
  if (!iso) return '18:00';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '18:00';
  return d.toLocaleTimeString('es-PE', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'America/Lima',
  });
}
